import { render, staticRenderFns } from "./RunsOnEverything.vue?vue&type=template&id=31f8a972"
import script from "./RunsOnEverything.vue?vue&type=script&lang=js"
export * from "./RunsOnEverything.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports